<template>
<v-layout>
  <v-flex>
  <v-tabs
      v-model="active"
    >
      <!-- <v-tab><h6>Server logs - EPM (Elk/G1)</h6></v-tab>
      <v-tab><h6>Server logs (Elk/G1)</h6></v-tab> -->
      <v-tab><h6>Server logs (Elk)</h6></v-tab>
      <!-- <v-tab><h6>Log Levels (collector box)</h6></v-tab> -->
      <v-tab><h6>Logs from collector box</h6></v-tab>
      <v-tab><h6>Log files from collector box</h6></v-tab>
      <!-- <v-tab-item>
        <legacy-epm-elklogs-subpanel></legacy-epm-elklogs-subpanel>
      </v-tab-item>
      <v-tab-item>
        <legacy-elklogs-subpanel></legacy-elklogs-subpanel>
      </v-tab-item> -->
      <v-tab-item>
        <elklogs-subpanel></elklogs-subpanel>
      </v-tab-item>
      <!-- <v-tab-item>
        <log-levels-subpanel></log-levels-subpanel>
      </v-tab-item> -->
      <v-tab-item>
        <logs-subpanel></logs-subpanel>
      </v-tab-item>
      <v-tab-item>
      <v-card flat>
            <v-card-title>
      <h3 class="headline mb-0 admin-header">Log Files</h3>
      <v-btn text icon color="grey lighten-1" @click="refreshLogFiles" :loading="loadingCollectors || loading">
        <v-icon>fas fa-sync</v-icon></v-btn>
      <v-select :items="allCollectors" v-model="selectedCollectorId"
      item-text="id" item-value="id" label="Source Collector"
      ></v-select>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="searchLogFiles"
        append-icon="fal fa-search"
        placeholder="Search"
        single-line
        hide-details
        clearable
      ></v-text-field>
    </v-card-title>
          <v-data-table
            :items="filteredLogFiles()"
            :search="searchLogFiles"
            :loading="loading"
            :headers="fileheaders"
            :options.sync="paginationFL"
            class="elevation-1"
          >
            <template v-slot:item.name="{item}">
              <td>
                <v-btn text color="blue" v-on:click="downloadFile(item.collector, item.name)">{{item.name}}</v-btn>
              </td>
            </template>
            <template v-slot:item.lastModified="{item}">
              <td>{{formatDateTime(item.lastModified)}}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-flex>
</v-layout>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
// import CollectorLogLevelsSubPanel from './CollectorLogLevelsSubPanel.vue'
import CollectorLogsSubPanel from './CollectorLogsSubPanel.vue'
import ElkLogsSubPanel from './ElkLogsSubPanel.vue'
// import LegacyElkLogsSubPanel from './LegacyElkLogsSubPanel.vue'
// import LegacyEpmElkLogsSubPanel from './LegacyEpmElkLogsSubPanel.vue'
import _ from 'lodash'
import moment from 'moment'
export default {
  components: {
    // 'log-levels-subpanel': CollectorLogLevelsSubPanel,
    'logs-subpanel': CollectorLogsSubPanel,
    'elklogs-subpanel': ElkLogsSubPanel
    // 'legacy-elklogs-subpanel': LegacyElkLogsSubPanel,
    // 'legacy-epm-elklogs-subpanel': LegacyEpmElkLogsSubPanel
  },
  data() {
    return {
      active: null,
      loading: false,
      loadingCollectors: false,
      searchLogFiles: '',
      paginationFL : {'sortBy': ['lastModified'], 'sortDesc': [true], 'rowsPerPage': 10},
        fileheaders: [
          {text: 'Name', align: 'left', sortable: true, value: 'name'},
          {text: 'Size', align: 'left', sortable: true, value: 'size'},
          {text: 'Last Modified', align: 'left', sortable: true, value: 'lastModified'},
          {text: 'Collector', align: 'left', sortable: true, value: 'collector'}
        ],
      selectedCollectorId: null
    }
  },
  watch: {
    orgContext: async function(val) {
      this.loadingCollectors = true
      await this.$store.dispatch('collectors/getCollectors')
      this.loadingCollectors = false
      this.loading = true
      await this.$store.dispatch('collectors/getLogs', this.filter)
      await this.$store.dispatch('collectors/getElkLogs', {})
      // await this.$store.dispatch('collectors/getLegacyElkLogs', {})
      // await this.$store.dispatch('collectors/getLegacyEpmElkLogs', {})
      await this.$store.dispatch('collectors/getLogFiles')
      this.loading = false
    }
  },
  computed: {
    ...mapGetters('collectors', {
        collectorlogfiles: 'getLogFiles',
        allCollectors: 'getCollectors'
    }),
    ...mapGetters('user', {
        orgContext: 'getOrgContext'
    })
  },
  async created () {
    this.loading = true
    await this.$store.dispatch('collectors/getLogFiles')
    this.loading = false
  },
  methods: {
    async refreshLogFiles() {
      this.loading = true
      await this.$store.dispatch('collectors/getLogFiles')
      this.loading = false
    },
    formatDateTime(val) {
      return moment(val).isValid() ? moment(val).format('MM/DD/YYYY, h:mm:ss a') : val
    },
    async downloadFile(collectorId, filename) {
      await this.$store.dispatch('collectors/downloadLogFile', {collectorId, filename})
    },
    filteredLogFiles() {
      if (!this.selectedCollectorId) {
        return this.collectorlogfiles
      }
      return _.filter(this.collectorlogfiles, {collector: this.selectedCollectorId})
    }
  }
}
</script>
